import React from 'react';

import getImageUrl from '../../../modules/getImageUrl';
import { Site } from '../../../modules/sites/Site';
import LazyImage from '../LazyLoad/LazyImage';

interface Props {
  site: Site;
  LazyImage: typeof LazyImage;
  className?: string;
  height?: number;
  width?: number;
}

const SiteLogo = ({
  className,
  site,
  LazyImage,
  width = 60,
  height = 30,
}: Props): JSX.Element | null => {
  if (!site.logo) {
    return null;
  }

  return (
    <LazyImage
      src={getImageUrl(`sites/${site.logo}`)}
      alt={site.label}
      className={`site-logo-${className}`}
      width={width}
      height={height}
    />
  );
};

export default SiteLogo;
